import { createQuery } from '@tanstack/svelte-query';
import { fetchLoads } from '$lib/api/load';
import { fetchRooms } from '$lib/api/room';
import { fetchZones } from '$lib/api/zone';
import type { LoadResponse } from '$lib/types/load';
import { resolveScope, getUnitScope, type ScopeFn } from './scope';

export const loadsQuery = (scope: ScopeFn = getUnitScope()) =>
	createQuery<Array<LoadResponse>>(() => {
		const unitId = resolveScope(scope);
		return {
			queryKey: ['loads', { unitId }],
			queryFn: async () => {
				const [allLoads, allRooms, allZones] = await Promise.all([
					fetchLoads(),
					fetchRooms(),
					fetchZones()
				]);
				const zoneIds = new Set(allZones.filter((z) => z.unit === unitId).map((z) => z.id));
				const roomIds = new Set(allRooms.filter((r) => zoneIds.has(r.zone)).map((r) => r.id));
				return allLoads.filter((l) => roomIds.has(l.room));
			},
			enabled: unitId > 0
		};
	});
